import cryptoUtils from '../utils/utils';
import base58 from '../utils/base58';

export default {
    isValidAddress(address) {
        return this.verifyChecksum(address);
    },
    verifyChecksum(address) {
        const decoded = base58.decode(address);
        const computedChecksum = cryptoUtils.sha256Checksum(cryptoUtils.toHex(decoded.slice(0, -4)));
        const checksum = cryptoUtils.toHex(decoded.slice(-4));
        if (decoded === null) {
            return false;
        }

        return decoded.length === 25 && (computedChecksum === checksum);
    },
};
